import {
  Check,
  CheckGroup,
  form,
  Form as AppForm,
  FormInput,
  FormRow,
  NumberInput,
  Select,
  TextArea
} from "MODULES/shared/components/Forms";
import React from "react";
import FormToggle from "MODULES/companies/shared/FindOrCreateCompanyToggle/FormToggle";
import { Field, FormSection } from "redux-form";
import { NOTES } from "APP_ROOT/constants";
import { arrayToProperCasedOptions, toOptions } from "LIB/forms";
import { properCase } from "LIB/formatters/text";
import { Col } from "react-bootstrap";
import {
  AVG_OVERHAUL,
  AVG_REPAIR,
  AVG_TEST,
  AWAITING_REPLY,
  BER_RATE,
  EVALUATION_FEE,
  NO_CAPES,
  OVERHAUL_TAT,
  QUOTE_TYPE,
  QUOTE_TYPES,
  REPAIR_QUOTE_LINE_ITEM,
  REPAIR_TAT,
  TEST_TAT
} from "MODULES/RepairQuotes/constants";
import CurrencyField from "MODULES/shared/components/Forms/CurrencyField";
import { searchRepairStationCompanies } from "MODULES/companies/actions";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import { clearForNoCapes } from "MODULES/RepairQuotes/helpers";
import { REPAIR_QUOTE_WARRANTY_PERIODS } from "MODULES/parts/constants";
import validate from "./validate";

const FORM_NAME = "repairQuoteForm";

function Form(props) {
  const { modal, submitting, getFieldValue, setFieldValue } = props;
  const quoteType = getFieldValue(
    [REPAIR_QUOTE_LINE_ITEM, QUOTE_TYPE].join(".")
  );
  const isNoCape = quoteType === NO_CAPES;
  const isAwaitingReply = quoteType === AWAITING_REPLY;

  return (
    <AppForm {...props} submitting={submitting} modal={modal}>
      <AppForm.Body>
        <FormRow>
          <Col md={6}>
            <Field
              name={[REPAIR_QUOTE_LINE_ITEM, QUOTE_TYPE].join(".")}
              component={Select}
              options={arrayToProperCasedOptions(QUOTE_TYPES)}
              label={properCase(QUOTE_TYPE)}
              onChange={ev => clearForNoCapes(ev, setFieldValue)}
              required
            />
          </Col>
          {quoteType === AWAITING_REPLY && (
            <Col md={6}>
              <CheckGroup justified>
                <Field name={"sendRfq"} component={Check} label="Send RFQ" />
              </CheckGroup>
            </Col>
          )}
        </FormRow>
        <FormToggle
          formName={FORM_NAME}
          type="repairOrder"
          companySearch={searchRepairStationCompanies}
          setPrimaryContact
        />
        <hr className="hr-sm" />
        <h4>Part Details</h4>

        <FormSection name={REPAIR_QUOTE_LINE_ITEM}>
          {!isNoCape && [
            <FormRow>
              <Col md={4}>
                <CurrencyField
                  name={AVG_OVERHAUL}
                  label={properCase(AVG_OVERHAUL)}
                  disabled={isAwaitingReply}
                />
              </Col>
              <Col md={2}>
                <Field
                  label="OH TAT"
                  disabled={isAwaitingReply}
                  name={OVERHAUL_TAT}
                  type="number"
                  className="text-right"
                  component={NumberInput}
                  roundDigits={0}
                />
              </Col>
              <Col md={4}>
                <CurrencyField
                  name={AVG_REPAIR}
                  label={properCase(AVG_REPAIR)}
                  disabled={isAwaitingReply}
                />
              </Col>
              <Col md={2}>
                <Field
                  label="SV TAT"
                  disabled={isAwaitingReply}
                  name={REPAIR_TAT}
                  type="number"
                  className="text-right"
                  component={NumberInput}
                  roundDigits={0}
                />
              </Col>
            </FormRow>,
            <FormRow>
              <Col md={4}>
                <CurrencyField
                  name={AVG_TEST}
                  label={properCase(AVG_TEST)}
                  disabled={isAwaitingReply}
                />
              </Col>
              <Col md={2}>
                <Field
                  label="BT TAT"
                  disabled={isAwaitingReply}
                  name={TEST_TAT}
                  type="number"
                  className="text-right"
                  component={NumberInput}
                  roundDigits={0}
                />
              </Col>
              <Col md={3}>
                <Field
                  name="warranty_period"
                  component={Select}
                  options={toOptions(REPAIR_QUOTE_WARRANTY_PERIODS)}
                  label="Warranty Period"
                  disabled={isAwaitingReply}
                />
              </Col>
            </FormRow>,
            <FormRow>
              <Col md={4}>
                <CurrencyField
                  name={EVALUATION_FEE}
                  label={properCase(EVALUATION_FEE)}
                  disabled={isAwaitingReply}
                />
              </Col>
              <Col md={4}>
                <Field
                  component={FormInput}
                  name={BER_RATE}
                  label={"BER %"}
                  disabled={isAwaitingReply}
                  parse={value => value && parseInt(value, 10)}
                  addon={<i className="fa fa-percent" />}
                />
              </Col>
            </FormRow>
          ]}
          <FormRow>
            <Col md={12}>
              <Field name={NOTES} component={TextArea} label="Note" rows={5} />
            </Col>
          </FormRow>
        </FormSection>
      </AppForm.Body>
    </AppForm>
  );
}

export default form({
  form: FORM_NAME,
  validate
})(withFieldAccessors(Form));



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/RepairQuotes/Create/Form.jsx